import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \"Seshy\"}}\n\n{{outlet}}\n\n<BasicDropdownWormhole />\n",{ moduleName: "seshy/templates/application.hbs" })